export function isReportShared(taskType) {
  // handle normal user
  switch (taskType) {
    case 'ReportUITemplate':
    case 'ReportUITemplateTest':
      return false;
    case 'ReportUICustomerTemplate':
    case 'ReportUICustomerTemplateTest':
    case 'ReportUIAccountTemplate':
    case 'ReportUIAccountTemplateTest':
    case 'ReportUIUserTemplate':
    case 'ReportUIUserTemplateTest':
      return true;
    default:
      throw new Error(`isReportShared: unhandled report type ${taskType}`);
  }
}
